var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2142",
    d: "M0-682.665H22v22H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42139",
    "data-name": "Group 42139",
    transform: "translate(636 -6094)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15865",
    "data-name": "Rectangle 15865",
    width: 24,
    height: 24,
    transform: "translate(-636 6094)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2136",
    transform: "translate(-560 6104.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42138",
    "data-name": "Group 42138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2138",
    transform: "translate(-75 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2140",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2146",
    transform: "translate(5.801 6.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2148",
    d: "M-260.653,0h-6.961a1.719,1.719,0,0,0-1.719,1.719v4.6a1.719,1.719,0,0,0,1.719,1.719h6.961a1.719,1.719,0,0,0,1.719-1.719v-4.6A1.719,1.719,0,0,0-260.653,0Z",
    transform: "translate(269.333 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2150",
    transform: "translate(8.507 0.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2152",
    d: "M-74.841,0a2.461,2.461,0,0,0-2.492,2.429v2.9",
    transform: "translate(77.333)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2154",
    transform: "translate(10.999 0.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2156",
    d: "M-74.841-159.887v-2.9a2.461,2.461,0,0,0-2.492-2.429",
    transform: "translate(77.333 165.212)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2158",
    transform: "translate(0.859 14.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2160",
    d: "M-532.919,0h1.246a1.289,1.289,0,0,1,1.289,1.289v4.34a1.289,1.289,0,0,1-1.289,1.289h-17.7a1.289,1.289,0,0,1-1.289-1.289V1.289A1.289,1.289,0,0,1-549.376,0h1.633",
    transform: "translate(550.665)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2162",
    transform: "translate(8.422 16.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2164",
    d: "M-51.614-25.807a.859.859,0,0,1-.859.859.859.859,0,0,1-.859-.859.859.859,0,0,1,.859-.859.859.859,0,0,1,.859.859",
    transform: "translate(53.333 26.667)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2166",
    transform: "translate(4.984 16.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2168",
    d: "M-51.614-25.807a.859.859,0,0,1-.859.859.859.859,0,0,1-.859-.859.859.859,0,0,1,.859-.859.859.859,0,0,1,.859.859",
    transform: "translate(53.333 26.667)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2170",
    transform: "translate(11.859 16.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2172",
    d: "M-51.614-25.807a.859.859,0,0,1-.859.859.859.859,0,0,1-.859-.859.859.859,0,0,1,.859-.859.859.859,0,0,1,.859.859",
    transform: "translate(53.333 26.667)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2174",
    transform: "translate(15.297 16.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2176",
    d: "M-51.614-25.807a.859.859,0,0,1-.859.859.859.859,0,0,1-.859-.859.859.859,0,0,1,.859-.859.859.859,0,0,1,.859.859",
    transform: "translate(53.333 26.667)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2178",
    transform: "translate(10.141 9.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2180",
    d: "M-51.614-25.807a.859.859,0,0,1-.859.859.859.859,0,0,1-.859-.859.859.859,0,0,1,.859-.859.859.859,0,0,1,.859.859",
    transform: "translate(53.333 26.667)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.7f995dab8b16fab391fa7124b8a57944.svg";
export { ForwardRef as ReactComponent };